import React from "react";
import "./BallByBall.css";
import { Container, Row, Col } from "react-bootstrap";
const img3 = require("../../../../assets/jsk/jsk1.jpg");

const BallByBall = () => {
  const data = [
    { label: "0 RUNS", value: "2.18", volume: "100K" },
    { label: "1 RUNS", value: "2.62", volume: "88.4K" },
    { label: "2 RUNS", value: "7.92", volume: "100K" },
    { label: "3 RUNS", value: "11", volume: "100K" },
    { label: "4 RUNS", value: "6.52", volume: "98.9K" },
    { label: "6 RUNS", value: "12.2", volume: "100K" },
    { label: "WICKET", value: "6.87", volume: "100K" },
    { label: "EXTRA RUNS", value: "8.67", volume: "100K" },
  ];
  return (
    <>
      <div className="ballbyball">
        <div className="bbb-page text-white">
          {/* Top Bar */}
          <div className="bbb-top d-flex justify-content-between align-items-center px-3 py-2">
            <strong>BALL BY BALL</strong>
            <span>36641120251121175352945</span>
          </div>

          {/* Banner Section */}
          <Container fluid className="p-0">
            <Row>
              <Col xs={12} className="p-0">
                <img src={img3} alt="Ball by Ball" className="bbb-banner" />
              </Col>
            </Row>
          </Container>

          {/* Runs Tab Bar */}
          <div className="bbb-tab d-flex justify-content-between px-3 py-2 fw-bold">
            <span>Runs</span>
            <span>Min/Max: 100 - 100000</span>
          </div>
        </div>
        <div className="">
          {/* Top Tabs */}
          <div className="tabs-section">
            <button className="tab active">All</button>
            <button className="tab">Match</button>
            <button className="tab">Odds/Evens</button>
            <button className="tab">Batsman</button>
            <button className="tab">Bowler</button>
            <button className="tab">Extra</button>
          </div>

          {/* Header */}
          <div className="bb-header">
            Ball By Ball
            <span className="info"> ⓘ </span>
          </div>

          {/* Table */}
          <div className="bb-table">
            {data.map((row, index) => (
              <div className="bb-row" key={index}>
                <div className="bb-label">{row.label}</div>
                <div className="bb-value">
                  <strong>{row.value}</strong>
                  <small>{row.volume}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BallByBall;
